import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { cvStyles } from './cvStyles';
import { cvConfig } from './cvConfig';
import { CVHeader } from './sections/CVHeader';
import { CVAbout } from './sections/CVAbout';
import { CVExperience } from './sections/CVExperience';
import { CVProjects } from './sections/CVProjects';
import { CVSkills } from './sections/CVSkills';
import { CVCertifications } from './sections/CVCertifications';

/**
 * Componente principal del documento CV
 * Genera un PDF profesional con toda la información del portfolio
 * 
 * @param {Object} cvData - Datos completos del CV obtenidos de useCVData
 */
export const CVDocument = ({ cvData }) => {
  if (!cvData) {
    return null;
  }

  return (
    <Document
      title={`CV - ${cvData.personal?.name || 'Portfolio'}`}
      author={cvData.personal?.name}
      subject="Curriculum Vitae"
      creator="Portfolio App"
    >
      <Page size="A4" style={cvStyles.page}>
        {/* Header con información personal */}
        <CVHeader personal={cvData.personal} />

        {/* Sobre mí */}
        {cvConfig.sections.about && cvData.about && (
          <CVAbout about={cvData.about} />
        )}

        {/* Experiencia laboral */}
        {cvConfig.sections.experience && cvData.experiences && (
          <CVExperience experiences={cvData.experiences} />
        )}

        {/* Proyectos */}
        {cvConfig.sections.projects && cvData.projects && (
          <CVProjects projects={cvData.projects} />
        )}

        {/* Skills */}
        {cvConfig.sections.skills && cvData.skills && (
          <CVSkills skills={cvData.skills} />
        )}

        {/* Certificaciones */}
        {cvConfig.sections.certifications && cvData.certifications && (
          <CVCertifications certifications={cvData.certifications} />
        )}

        {/* Footer */}
        {cvConfig.footer.show && (
          <View style={cvStyles.footer} fixed>
            <Text>{cvConfig.footer.text}</Text>
          </View>
        )}
      </Page>
    </Document>
  );
};
